export const SET_LOADING = "SET_LOADING";
export const SET_ERROR = "SET_ERROR";

export const RECEIVE_CREATE_VOICE_REPLACE_SUCCESS =
  "RECEIVE_CREATE_VOICE_REPLACE_SUCCESS";
export const RECEIVE_FETCH_TRASHBIN_VOICE_REPLACE_SUCCESS =
  "RECEIVE_FETCH_TRASHBIN_VOICE_REPLACE_SUCCESS";
